import React from 'react';

export const ReturnedIcon = () => {
  return (
    <path id="Path_727" data-name="Path 727" d="M387,638h10a8,8,0,0,0,8-8v-2m-18,10,6-6m-6,6,6,6"
          transform="translate(-380 -615)" fill="none" stroke="#c7372e" strokeLinecap="round" strokeLinejoin="round"
          strokeWidth="2"/>
  );
};
